module.exports = __webpack_public_path__ + "static/media/3DVAM.2e19009d.png";